module.exports = __webpack_public_path__ + "img/l_c3.8da3d231.png";